var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBuilding1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.667 39.875a1.375 1.375 0 0 1-.187-2.737l.187-.013h2.29l.001-15.15a5.486 5.486 0 0 1-1.824-3.777l-.009-.323v-.229a5.49 5.49 0 0 1 .573-2.458l.205-.375 3.85-6.407a5.042 5.042 0 0 1 3.97-2.435l.352-.013h17.852A5.042 5.042 0 0 1 35.05 8.11l.191.295 3.85 6.407a5.49 5.49 0 0 1 .768 2.404l.017.426v.233a5.486 5.486 0 0 1-1.832 4.099l-.001 15.15 2.291.001a1.375 1.375 0 0 1 .187 2.737l-.187.013H3.667zM30.25 21.513a5.486 5.486 0 0 1-4.125 1.862A5.487 5.487 0 0 1 22 21.513a5.486 5.486 0 0 1-4.125 1.862 5.487 5.487 0 0 1-4.125-1.862 5.486 5.486 0 0 1-5.042 1.786v13.825h2.75v-8.707c0-1.187.902-2.163 2.058-2.28l.234-.012h4.583c1.187 0 2.163.902 2.28 2.057l.012.235v8.707h14.667V23.3a5.487 5.487 0 0 1-5.042-1.786zm-12.375 7.362h-3.667v8.25h3.667v-8.25zm13.292-2.75a2.292 2.292 0 0 1 2.291 2.292v3.666a2.292 2.292 0 0 1-2.291 2.292h-5.5a2.292 2.292 0 0 1-2.292-2.292v-3.666a2.292 2.292 0 0 1 2.292-2.292zm-.459 2.75h-4.583v2.75h4.583v-2.75zm-10.083-11h-5.5a2.75 2.75 0 0 0 5.487.265l.013-.265zm-8.25 0h-5.5c0 .915.447 1.725 1.134 2.225l.062.04.06.041c.36.237.779.388 1.23.431l.264.013a2.75 2.75 0 0 0 2.737-2.485l.013-.265zm16.5 0h-5.5a2.75 2.75 0 0 0 5.487.265l.013-.265zm8.25 0h-5.5a2.75 2.75 0 0 0 2.485 2.737l.265.013a2.75 2.75 0 0 0 2.737-2.485l.013-.265zm-6.2-9.167h-17.85c-.715 0-1.384.334-1.815.894l-.15.22-3.186 5.302H36.07l-3.188-5.303a2.292 2.292 0 0 0-1.693-1.097l-.264-.016z",
    fill: "#9EA2FA",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBuilding1);
export default __webpack_public_path__ + "static/media/icons-building-1.5858813e75ff70371a6250ce13248026.svg";
export { ForwardRef as ReactComponent };